/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

const Badge: FunctionComponent<{ text?: string; uppercase?: boolean; lowercase?: boolean }> = ({
    text = '',
    uppercase = false,
    lowercase = false,
}) => {
    if (!text) return null;
    let formattedText = text.trim();
    if (lowercase) formattedText = formattedText.toLowerCase();
    if (uppercase) formattedText = formattedText.toUpperCase();
    return (
        <span className="uikit badge primary-text-style text-size-small primary-color text-bold">
            {formattedText}
        </span>
    );
};

export default Badge;
